import { gql } from "@apollo/client";

export const PUBLISH_STARTUP_MUTATION = gql`
  mutation PublishStartup($input: PublishInput!) {
    # Use PublishInput instead of PublishStartupInput
    publishStartup(input: $input) {
      statusCode
      message
      status
    }
  }
`;
